import type { CandidateView } from "@portal/schemas";
import { Badge } from "@portal/ui";

export const CANDIDATE_STATUS_LABELS: Record<CandidateView["status"], string> = {
  PENDING: "未処理",
  APPROVED: "承認済み",
  // 操作は「承認」と「非表示」だけ(ユーザー要望 2026-10-15)。却下(REJECTED)は画面では「非表示」と呼ぶ
  REJECTED: "非表示",
  ON_HOLD: "保留",
};

const VARIANTS: Record<CandidateView["status"], "warning" | "success" | "neutral" | "outline"> = {
  PENDING: "warning",
  APPROVED: "success",
  REJECTED: "outline",
  ON_HOLD: "neutral",
};

export function CandidateStatusBadge({ status }: { status: CandidateView["status"] }) {
  return <Badge variant={VARIANTS[status]}>{CANDIDATE_STATUS_LABELS[status]}</Badge>;
}

export const OUTCOME_LABELS: Record<CandidateView["outcome"], string> = {
  WON: "受注",
  ENDED: "完了",
};
